import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { AuthServiceService } from './auth-service.service';
import { AnalyticsResponse } from '../models/analytics.model';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    get _liveApiUrl() {
        return this.authService._liveApiUrl;
    }

    constructor(
        private http: HttpClient,
        public authService: AuthServiceService
    ) { }

    /**
     * Get analytics view data for a specific date range
     * @param startDate YYYY-MM-DD
     * @param endDate YYYY-MM-DD
     */
    getAnalyticsView(startDate: string, endDate: string): Observable<AnalyticsResponse> {
        const params = {
            start_date: startDate,
            end_date: endDate
        };

        return this.http.get<AnalyticsResponse>(`${this._liveApiUrl}/company/analytics-view/`, { params }).pipe(
            map((data: any) => {
                return data;
            }),
            catchError((error) => this.authService.handleError(error))
        );
    }
}
